import React, { useRef, useState } from "react";
import { getFiledValue, getPersianDateObj } from "../../../constant/helper";
import { message, Rate, Skeleton, Typography } from "antd";
import brokenImage from "../images/broken.png";
import { Link } from "react-router-dom";
import { addUserRate } from "../blog.api";
import ShareGroupButton from "../../../components/ShareGroupButton";
//import ContentBodyPerType from "./ContentBodyPerType";
// import brokenImage from "../images/sebastian-pichler-bAQH53VquTc-unsplash@2x.png";

const { Title, Paragraph } = Typography;

const ConstItem = ({
  i,
  loading = false,
  isSummary = true,
  showRating = true,
  isRating = true,
  isSharing = true,
}) => {
  const bannerRef = useRef();
  const date = getPersianDateObj(i.publishDate);
  const [rateError, setRateError] = useState(false);

  const handleBrokenBanner = () => {
    bannerRef.current.src = brokenImage;
  };

  const handleRateToContent = (rate) => {
    if (rateError) {
      return false;
    }

    addUserRate(i.id, rate)
      .then((res) => {
        message.success("رای شما با موفقیت ثبت شد");
      })
      .catch((err) => {
        if (
          err.hasOwnProperty("response") &&
          err.response.hasOwnProperty("status") &&
          err.response.status === 409
        ) {
          message.error("راي شما قبلا ثبت گردیده است");
          setRateError(true);
        } else {
          message.error("خطایی در اطلاعات");
        }
      });
  };

  function nothingRate(e) {}

  return (
    <Skeleton loading={loading} active avatar>
      <section
        className={`list-item ${isRating || isSharing ? "full-item" : ""}`}
      >
        <div>
          <Link to={`/blog/${i?.id}`}>
            <div
              className="image"
              style={{
                overflow: "hidden",
              }}
            >
              <img
                className="image"
                src={i.banner ? getFiledValue(i.banner) : brokenImage}
                alt="بنر"
                onError={handleBrokenBanner}
                ref={bannerRef}
              />
            </div>
          </Link>
          <div className="wrap-description">
            <small className="date">
              {date.day} <br /> {date.monthName}
              <br /> {date.year}
            </small>
            <div className="author-time">
              {/* <div className="author">
                <small>نویسنده : </small>{" "}
                <strong> {i.author && i.author.name && i.author.name} </strong>
              </div> */}
              <div className="time">
                <small> مدت مطالعه : </small>
                <strong>{i.studyDuration || 0} دقیقه</strong>
              </div>
            </div>
            <div
              className="rating"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              style={{
                userSelect: "none",
              }}
            >
              {showRating ? (
                <>
                  <Rate
                    disabled
                    value={i.averageRate}
                    allowHalf
                    onChange={nothingRate}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    style={{
                      userSelect: "none",
                    }}
                  />
                  {typeof i.ratesCount !== "undefined" &&
                  Number(i.ratesCount) > 0
                    ? `${i.ratesCount} رای ثبت شده`
                    : `رای ثبت نشده`}
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          <Link to={`/blog/${i?.id}`}>
            <Title className="content-title" ellipsis={{ rows: 2 }}>
              {getFiledValue(i.title)}
            </Title>
          </Link>
          <div className="content-body">
            {isSummary && (
              <Paragraph ellipsis={{ rows: 3 }}>
                {getFiledValue(i.summary)}
              </Paragraph>
            )}
            {!isSummary &&
              i.content &&
              i.content.length > 0 &&
              i.content.map((item, i) => (
                <p className="selectable-text  justify-text">
                  {item.fields[0]}
                </p>
              ))}

            {/*   <ContentBodyPerType key={i} content={item} />*/}
          </div>
          {isSummary && (
            <div className="show-more">
              <Link to={`/blog/${i?.id}`}>بیشتر بخوانید ...</Link>
            </div>
          )}
        </div>

        {isRating || isSharing ? (
          <div className="share-rate">
            <div className="submit-rating">
              {isRating ? (
                <>
                  ثبت نظر :
                  <Rate
                    defaultValue={0}
                    allowHalf={false}
                    onChange={handleRateToContent}
                  />
                </>
              ) : (
                ""
              )}
            </div>
            {isSharing ? (
              <ShareGroupButton
                url={`https://lawin.co/blog/${i.id}`}
                title={getFiledValue(i.title)}
              />
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </section>
    </Skeleton>
  );
};

export default ConstItem;
